const e = "style-module__shinyBorderContainer___S56O-", t = "style-module__chatInput___eRGXK", _ = "style-module__chatInputContainer___6z7-o", n = "style-module__actions___HoJ1V", o = "style-module__disabled___Z0RUa", s = "style-module__inputs___yi0Q5", r = "style-module__noFiles___90hgV", l = "style-module__truncateOnBlurContainer___AJmuR", a = "style-module__textareaInput___mZP78", u = "style-module__withPreTextIcon___L-Ypa", c = "style-module__withTruncate___eSCoO", d = "style-module__files___RBEoS", p = "style-module__fileInput___JIo-7", i = "style-module__attachButton___0HvDC", m = "style-module__hasText___9HuVj", y = "style-module__sendButton___uDqXf", h = "style-module__sendArrowImageWrapper___uFHTa", I = "style-module__sendArrowWrapperHover___emgh3", w = "style-module__sendArrowWrapper___Sb07B", x = "style-module__sendArrow___pxG7G", B = "style-module__overlapping___R1yLI", A = "style-module__preTextIcon___jd5co", T = {
  shinyBorderContainer: e,
  chatInput: t,
  chatInputContainer: _,
  actions: n,
  disabled: o,
  inputs: s,
  noFiles: r,
  truncateOnBlurContainer: l,
  textareaInput: a,
  withPreTextIcon: u,
  withTruncate: c,
  files: d,
  fileInput: p,
  attachButton: i,
  hasText: m,
  sendButton: y,
  sendArrowImageWrapper: h,
  sendArrowWrapperHover: I,
  sendArrowWrapper: w,
  sendArrow: x,
  overlapping: B,
  preTextIcon: A
};
export {
  n as actions,
  i as attachButton,
  t as chatInput,
  _ as chatInputContainer,
  T as default,
  o as disabled,
  p as fileInput,
  d as files,
  m as hasText,
  s as inputs,
  r as noFiles,
  B as overlapping,
  A as preTextIcon,
  x as sendArrow,
  h as sendArrowImageWrapper,
  w as sendArrowWrapper,
  I as sendArrowWrapperHover,
  y as sendButton,
  e as shinyBorderContainer,
  a as textareaInput,
  l as truncateOnBlurContainer,
  u as withPreTextIcon,
  c as withTruncate
};
